import { Component, inject } from '@angular/core';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-common-toast',
  imports: [],
  templateUrl: './common-toast.html',
  styleUrl: './common-toast.css',
})
export class CommonToast {
   readonly toastService = inject(ToastService);
}
